
<template>
  <div class="indexDataShow" :dataShow='dataShow'>
    <el-row :gutter="20">
      <el-col :span="6" v-for="(item,index) in dataShow" :key="index">
        <div class="indexDataShowLable">
          <p class="indexDataShowLableTop">
            <span class="indexDataShowLableTopNumber">{{item.num}}</span>
            <span class="indexDataShowLableTopUnit">{{language == 'zh' ? item.unitCn : item.unitEn}}</span>
          </p>
          <p class="indexDataShowLableBottom">{{language == 'zh' ? item.tipsCn : item.tipsEn}}</p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    dataShow: {
      type: [Object, String, Array],
      default: () => ''
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['language']),
  },
  mounted() {},
  methods: {},
  created() {}
}
</script>

<style lang="stylus" scoped>
</style>
